import { Upload, Play } from "lucide-react";

const MediaFrame = ({
  label = "Media Upload Slot",
  sub,
  aspect = "aspect-video",
  icon: Icon = Upload,
  className = "",
}) => (
  <div
    data-testid="media-frame"
    className={`relative ${aspect} rounded-2xl border-2 border-dashed border-purple-200 bg-lavender-50 flex flex-col items-center justify-center gap-3 text-center px-6 ${className}`}
  >
    <div className="w-12 h-12 rounded-full bg-purple-100 border border-purple-200 flex items-center justify-center shrink-0">
      <Icon className="w-5 h-5 text-purple-600" />
    </div>
    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-slate-600">{label}</p>
    {sub && <p className="text-xs text-slate-500 max-w-xs leading-relaxed">{sub}</p>}
  </div>
);

export { Play };
export default MediaFrame;